import type { ComponentProps } from 'react';

import { WidgetChip } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove.ts';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';

import { DumbFeaturedCollectionTaskWidget } from '#src/components/missions/DumbFeaturedCollectionTaskWidget/index.tsx';

type Props = {
  to: string;
  onDesktopClick?: () => void;
  myUnclaimedCollectionTasksCount: number;
} & Pick<ComponentProps<typeof DumbFeaturedCollectionTaskWidget>, 'size'>;

export const ProFeaturedCollectionTaskWidget = ({
  to,
  onDesktopClick,
  myUnclaimedCollectionTasksCount,
  size = 5,
}: Props) => {
  const isDesktop = useIsDesktopAndAbove();
  const enableSorare27Nav = useEnableSorare27Nav();

  if (!enableSorare27Nav) {
    return null;
  }

  const chip =
    myUnclaimedCollectionTasksCount > 0 ? (
      <WidgetChip state="reward" />
    ) : undefined;

  if (isDesktop && onDesktopClick) {
    return (
      <DumbFeaturedCollectionTaskWidget
        chip={chip}
        size={size}
        progresses={[1]}
        onClick={onDesktopClick}
      />
    );
  }

  return (
    <DumbFeaturedCollectionTaskWidget
      chip={chip}
      size={size}
      progresses={[1]}
      to={to}
    />
  );
};
